module.exports = __webpack_public_path__ + "img/digital.7eb875b3.png";